/* Each bundle slot is one real Shopify variant, including linked colour products. */
(() => {
  function init(scope) {
    scope.querySelectorAll('[data-gx-product]').forEach(root => {
      const data = root.querySelector('[data-gx-bundle-json]');
      if (!data || root.dataset.bundleReady) return;
      root.dataset.bundleReady = 'true';
      const parsed = JSON.parse(data.textContent);
      const {products, currency} = parsed;
      const discountCodes = parsed.discountCodes || {};
      const form = root.querySelector('.gx-pdp__form');
      const panel = root.querySelector('[data-gx-bundle]');
      const container = panel.querySelector('[data-gx-bundle-items]');
      const status = panel.querySelector('[data-gx-bundle-status]');
      const quantity = root.querySelector('[data-gx-quantity-input]');
      const variantInput = root.querySelector('[data-gx-variant-input]');
      const button = root.querySelector('[data-gx-add]');
      const buttonLabel = root.querySelector('[data-gx-add-label]');
      const tiers = [...root.querySelectorAll('[data-gx-tier]')];
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}).format(cents / 100);
      const tierDiscount = count => {
        const tier = tiers.find(item => Number(item.dataset.gxTierQty) === count);
        if (tier && tier.dataset.gxTierDiscount != null && tier.dataset.gxTierDiscount !== '') {
          return Math.max(0, Number(tier.dataset.gxTierDiscount) || 0);
        }
        if (count === 2) return 10;
        if (count === 3) return 20;
        return 0;
      };
      const applyDiscount = (cents, count) => {
        const pct = tierDiscount(count);
        return Math.round(cents * (100 - pct) / 100);
      };
      let slots = [], busy = false;
      const hideUnavailable = root.hasAttribute('data-gx-hide-unavailable');
      const current = () => products[0].variants.find(v => String(v.id) === variantInput.value) || products[0].variants[0];
      const resolve = slot => slot.product.variants.find(v => v.options.every((v,i) => v === slot.choices[i]));
      function update() {
        const selected = slots.map(resolve);
        const valid = selected.every(v => v?.available);
        button.disabled = busy || !valid;
        buttonLabel.textContent = busy ? window.GX.s('adding', 'ADDING…') : valid ? window.GX.s('add', 'ADD TO BAG') : window.GX.s('unavailable', 'UNAVAILABLE');
        const availability = root.querySelector('[data-gx-availability]');
        availability.textContent = valid ? window.GX.s('inStock', '● IN STOCK') : window.GX.s('selectAvailableOptions', 'SELECT AVAILABLE OPTIONS');
        availability.style.color = valid ? '#5b7e4a' : '#a33';
        const fullSum = selected.every(Boolean) ? selected.reduce((sum,v) => sum + v.price,0) : 0;
        const discountedSum = selected.every(Boolean) ? applyDiscount(fullSum, slots.length) : 0;
        root.querySelector('[data-gx-price]').textContent = selected.every(Boolean) ? money(discountedSum) : '—';
        tiers.forEach(tier => {
          const count = Number(tier.dataset.gxTierQty);
          const active = count === slots.length;
          const full = current().price * count;
          const discounted = applyDiscount(full, count);
          tier.classList.toggle('is-selected',active);
          tier.querySelector('input').checked = active;
          tier.querySelector('b').textContent = active ? root.querySelector('[data-gx-price]').textContent : money(discounted);
          let compare = tier.querySelector('s');
          if (tierDiscount(count) > 0) {
            if (!compare) {
              compare = document.createElement('s');
              tier.querySelector('.gx-pdp__tier-price')?.append(compare);
            }
            compare.hidden = false;
            compare.textContent = money(full);
          } else if (compare) {
            compare.hidden = true;
          }
        });
        const express = root.querySelector('.gx-pdp__actions-row--buy');
        if (express) express.hidden = slots.length > 1 || !selected[0]?.available || String(selected[0].id) !== variantInput.value;
      }
      function render() {
        container.replaceChildren();
        panel.hidden = false;
        slots.forEach((slot,index) => {
          const row = document.createElement('fieldset'); row.className = 'gx-bundle__item';
          const legend = document.createElement('legend'); legend.textContent = `${window.GX.s('itemLabel', 'Item')} ${index + 1}`; row.append(legend);
          function select(label, values, value, change) {
            const wrapper = document.createElement('label'); wrapper.textContent = label;
            const control = document.createElement('select');
            values.forEach(entry => { const option = document.createElement('option'); option.value = entry.value; option.textContent = entry.label; control.append(option); });
            control.value = value;
            control.addEventListener('change', () => { status.textContent = ''; change(control.value); render(); });
            wrapper.append(control); row.append(wrapper);
          }
          if (products.length > 1) select(window.GX.s('colourProduct', 'Colour / product'), products.map(p => ({value:String(p.id),label:p.title})), String(slot.product.id), id => {
            slot.product = products.find(p => String(p.id) === id);
            slot.choices = [...(slot.product.variants.find(v => v.available) || slot.product.variants[0]).options];
          });
          slot.product.options.forEach((name,i) => {
            if (name === 'Title' && slot.product.variants.length === 1 && slot.choices[i] === 'Default Title') return;
            const values = [...new Set(slot.product.variants
              .filter(v => (!hideUnavailable || v.available) && v.options.every((val, idx) => idx === i || val === slot.choices[idx]))
              .map(v => v.options[i]))];
            if (hideUnavailable && values.length && !values.includes(slot.choices[i])) slot.choices[i] = values[0];
            select(name,values.map(value => ({value,label:value})),slot.choices[i],value => { slot.choices[i] = value; });
          });
          const variant = resolve(slot);
          const summary = document.createElement('p'); summary.className = 'gx-bundle__summary';
          summary.textContent = variant?.available ? money(variant.price) : window.GX.s('combinationUnavailable', 'This combination is unavailable. Choose another option.');
          row.append(summary); container.append(row);
        });
        update();
      }
      function resize(value) {
        const count = Math.max(1, Math.min(50, parseInt(value,10) || 1));
        quantity.value = count;
        slots = Array.from({length:count},(_,i) => slots[i] || {product:products[0],choices:[...current().options]});
        render();
      }
      tiers.forEach(tier => tier.querySelector('input').addEventListener('change', () => resize(tier.dataset.gxTierQty)));
      quantity.addEventListener('change', () => resize(quantity.value));
      root.querySelectorAll('[data-gx-quantity-minus],[data-gx-quantity-plus]').forEach(b => b.addEventListener('click', () => resize(quantity.value)));
      root.querySelectorAll('[data-gx-option-value]').forEach(b => b.addEventListener('click', () => {
        slots[0] = {product:products[0],choices:[...current().options]}; render();
      }));
      const addBundle = async event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (busy) return;
        const variants = slots.map(resolve);
        if (variants.some(v => !v?.available)) { status.textContent = window.GX.s('chooseAvailableOptions', 'Choose available options for every item.'); return; }
        const items = [];
        variants.forEach(v => { const item = items.find(item => item.id === v.id); if (item) item.quantity++; else items.push({id:v.id,quantity:1}); });
        busy = true; update(); status.textContent = '';
        try {
          const base = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${base}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || window.GX.s('unableToAdd', 'Unable to add these items. Please try again.'));
          const code = discountCodes[String(slots.length)] || (slots.length >= 3 ? discountCodes['3'] : '') || '';
          if (code) {
            window.location.assign(`${base}discount/${encodeURIComponent(code)}?redirect=/cart`);
            return;
          }
          window.location.assign(`${base}cart`);
        } catch (error) { status.textContent = error.message; busy = false; update(); }
      };
      button.addEventListener('click', addBundle, true);
      form.addEventListener('submit', addBundle, true);
      resize(tiers.find(t => t.querySelector('input').checked)?.dataset.gxTierQty || quantity.value);
    });
  }
  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
